const iconStyles = {
  svg: {
    height: '15px',
    width: '15px',
  },
};

export default iconStyles;
